import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';

import {
  BuyerUploadedRespondentListResponseDto,
  ClearRespondentListResponseDto,
  UploadRespondentListResponseDto,
} from './dtos/respondent-list.dto';
import { RespondentListMapper } from './mappers/respondent-list.mapper';

@Injectable({ providedIn: 'root' })
export class RespondentListApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new RespondentListMapper();

  public upload(surveyId: number, file: File): Observable<string[]> {
    const formData = new FormData();
    formData.append('psid_ref_file', file);

    return this._http
      .post<UploadRespondentListResponseDto>(
        `${this._baseUrl}/inclexcl/uploadPSIDListFromUI/${surveyId}`,
        formData,
        { context: withLoading('content') },
      )
      .pipe(map((dto) => this._mapper.fromUploadDto(dto)));
  }

  public getUploadedList(
    surveyId: number,
    inclExcl: 0 | 1,
  ): Observable<string[]> {
    return this._http
      .get<BuyerUploadedRespondentListResponseDto>(
        `${this._baseUrl}/inclexcl/getBuyerUploadedList/${surveyId}`,
        { params: { incl_excl: inclExcl } },
      )
      .pipe(map((dto) => this._mapper.fromUploadedListDto(dto)));
  }

  public clear(surveyId: number): Observable<void> {
    return this._http
      .delete<ClearRespondentListResponseDto>(
        `${this._baseUrl}/inclexcl/clearUploadedPSIDs/${surveyId}`,
        { context: withLoading('content') },
      )
      .pipe(map(() => undefined));
  }
}
